export enum Locales {
  ru = 'ru',
  kz = 'kz',
}
